import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GalleryItemWrapper } from '../../styles';
import Card from './Gallery.card';

export const SortableGalleryItem = ({ image, zoomLevel, onClick }: any) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: image.id });

  const style = { transform: CSS.Transform.toString(transform), transition};
  const baseCardSize = 200;
  const size = baseCardSize * zoomLevel;
  const [mouseDown, setMouseDown] = useState<{ x: number; y: number } | null>(null);

  const handleMouseDown = (e: React.MouseEvent) => { setMouseDown({ x: e.clientX, y: e.clientY });};

  const handleMouseUp = (e: React.MouseEvent) => {
    if (mouseDown) {
      const dx = Math.abs(e.clientX - mouseDown.x);
      const dy = Math.abs(e.clientY - mouseDown.y);
      const distance = Math.sqrt(dx * dx + dy * dy);
      if (distance < 5) onClick();
    }
    setMouseDown(null);
  };

  return (
    <GalleryItemWrapper
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      size={size}
      style={style}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <Card
        absolutePath={image.absolutePath}
        imageName={image.name}
        zoomLevel={zoomLevel}
      />
    </GalleryItemWrapper>
  );
};